import { RefundPassengerDocument } from '@entities/refund';
import { fileToBase64 } from '@shared/lib/file-upload';
import { ExareInputFile } from '@websky/graphql';

export const prepareExareInputFiles = async (documents: RefundPassengerDocument[]) => {
	const files: ExareInputFile[] = [];
	const errors: { document: RefundPassengerDocument; error: unknown }[] = [];

	for (const document of documents) {
		for (const file of document.files) {
			try {
				if (!file.error) {
					const content = await fileToBase64(file.file);

					files.push({
						content,
						originalFileName: file.file.name,
						type: document.documentType,
						passengerId: document.passengerId
					});
				}
			} catch (error) {
				errors.push({ document, error });
			}
		}
	}

	return { files, errors };
};
